import styled, {useTheme} from 'styled-components';
import vars from '../root';

const LargeContentConianerDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
  flex-wrap: wrap;
  width: calc(100% - ${vars.RIGHT_MENU_WIDTH}px);
  min-height: calc(100vh - 60px);
`;

export function LargeContentConianer({
  style,
  children,
  showBackgroundColor = true,
}) {
  const theme = useTheme();
  return (
    <LargeContentConianerDiv
      className="large-content-container"
      style={{
        ...style,
        ...{
          backgroundColor: showBackgroundColor
            ? theme.colors.background.primary
            : 'unset',
        },
      }}>
      {children}
    </LargeContentConianerDiv>
  );
}
